import { axios, API } from "@/imports-files/common/common";
import { SendRequest } from "@/imports-files/pages/admins/logout";

export class JobLivePopupService extends SendRequest
{
    // set the api for the data
    async updateLiveJobPopupStatus(params)
    {
        const url =  API.client.jobs.UPDATE_JOB_LIVE_MODAL_SHOW_STATUS_FALSE;
        try
        {
            const result = await axios.post(url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        }
        catch (error)
        {
          return error;
        }
    }

}
